import { useState, useCallback } from 'react'
import { apiCheckCampaignUsage } from '../../../services/Campaign'

export {
  useRegister,
  usePersonalInfo,
  useParametersAddress,
  useRegisterSave,
  useRegisterSaveCoupon,
} from '../../Auth/Register/hooks'

export const useCampaignDniCheck = () => {
  const [isChecking, setIsChecking] = useState(false)
  const [alreadyUsedError, setAlreadyUsedError] = useState(null)

  const getPromotionId = () => {
    const campaignData = sessionStorage.getItem('campaignData')
    if (!campaignData) return 1
    try {
      const parsed = JSON.parse(campaignData)
      return parsed?.data?.id ?? 1
    } catch {
      return 1
    }
  }

  const checkDniUsage = useCallback(
    (dni) => {
      if (!dni || dni.trim().length < 8) {
        setAlreadyUsedError(null)
        return Promise.resolve({ hasUsed: false, resData: null })
      }
      setIsChecking(true)
      setAlreadyUsedError(null)
      const promotionId = getPromotionId()
      return apiCheckCampaignUsage(dni.trim(), promotionId)
        .then((res) => {
          const hasUsed = res.data?.data?.hasUsed ?? false
          if (hasUsed) {
            setAlreadyUsedError('Ya utilizó este beneficio anteriormente')
          } else {
            setAlreadyUsedError(null)
          }
          return { hasUsed, resData: res.data?.data }
        })
        .catch(() => {
          setAlreadyUsedError(null)
          return { hasUsed: false, resData: null }
        })
        .finally(() => setIsChecking(false))
    },
    []
  )

  return { checkDniUsage, isChecking, alreadyUsedError, clearError: () => setAlreadyUsedError(null) }
}
